import { ref } from 'vue';

// Singleton compartilhado por ReplyBoxBanner / ConversationAction / contextMenu.
// blocked = agente atual (não-admin) está com a caixa cheia -> esconder o
// self-assign. Backend: GET /api/v1/accounts/:id/self_assign_capacity.
const isSelfAssignBlocked = ref(false);
let lastFetchAt = 0;
let inFlight = null;

export function selfAssignBlockedRef() {
  return isSelfAssignBlocked;
}

// throttle 4s; force=true ignora o throttle (após atribuir/resolver).
export function refreshSelfAssignCapacity(accountId, { force = false } = {}) {
  if (!accountId) return Promise.resolve();
  const now = Date.now();
  if (!force && now - lastFetchAt < 4000) return Promise.resolve();
  if (inFlight) return inFlight;
  lastFetchAt = now;
  inFlight = window.axios
    .get(`/api/v1/accounts/${accountId}/self_assign_capacity`)
    .then(({ data }) => {
      isSelfAssignBlocked.value = !!data?.blocked;
    })
    .catch(() => {
      // fail-open: em erro NÃO esconde o botão (não trava o fluxo).
      isSelfAssignBlocked.value = false;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}
